//
// # "Solder" Dot
//

// Local Imports
import { Bbox, Point } from "../model";
import * as graphics from "../graphics";

// # Dot
export interface SolderDot {
  center: Point; // Center Location
  radius: number; // Radius
}
export const SolderDot = {
  BIG_RADIUS: 10,
  LIL_RADIUS: 5,
  new: (center: Point, radius: number): SolderDot => ({ center, radius }),
  default: (): SolderDot =>
    SolderDot.new(Point.new(0, 0), SolderDot.LIL_RADIUS),
  from: (partial: Partial<SolderDot>): SolderDot => ({
    ...SolderDot.default(),
    ...partial,
  }),
  bboxCenter: (dot: SolderDot): Point => {
    return dot.center;
  },
  translate: (dot: SolderDot, delta: Point): SolderDot => ({
    radius: dot.radius,
    center: Point.add(dot.center, delta),
  }),
  ellipse: (dot: SolderDot): graphics.Ellipse =>
    graphics.Ellipse.fromPartial({
      filled: true,
      bbox: Bbox.fromSizeAndCenter(
        { width: dot.radius * 2, height: dot.radius * 2 },
        dot.center
      ),
    }),
};
